// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner-wr":"Loader_lds-spinner-wr__1d0Dq","lds-spinner":"Loader_lds-spinner__13-rq"};